import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import GridWrapper from "../atoms/GridWrapper"
import Main from "../organisms/selection/MainContents"
import Pending from "../organisms/selection/Pending"
import Title from "../atoms/Title"
import TitleDescription from "../atoms/TitleDescription"
import { withStyles } from "@material-ui/core/styles"
import { colors, templateStyles } from "../constants"

class Selection extends Component {
  render() {
    const { classes } = this.props
    return (
      <>
        <GridWrapper>
          <Grid>
            <Grid className={classes.grid}>
              <Grid>
                <Title className={classes.title}>Selection</Title>
              </Grid>
              <Grid>
                <TitleDescription>
                  経済学部のみならず、他学部からの募集も積極的に行なっています。
                </TitleDescription>
              </Grid>
            </Grid>
          </Grid>
        </GridWrapper>
        <Grid style={{ backgroundColor: colors.backGround, padding: "30px" }}>
          {/* <Main /> */}
          <Pending />
        </Grid>
      </>
    )
  }
}

export default withStyles(templateStyles)(Selection)
